import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import InappropriateWordsEditor from './Inappropriate';

const TAB_TYPES = {
  COMMON: 'common',
  VOCABULARY: 'vocabulary',
  STORY: 'story',
  ASSIGNMENT: 'assignment'
};

export default function InappropriateWordsManager() {
  const [currentTab, setCurrentTab] = useState(TAB_TYPES.COMMON);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
        <Tabs value={currentTab} onChange={handleTabChange}>
          <Tab label="Common" value={TAB_TYPES.COMMON} />
          <Tab label="Vocab/Cognates/Phrases" value={TAB_TYPES.VOCABULARY} />
          <Tab label="Story" value={TAB_TYPES.STORY} />
          <Tab label="Assignment" value={TAB_TYPES.ASSIGNMENT} />
        </Tabs>
      </Box>
      <InappropriateWordsEditor context={currentTab} />
    </Box>
  );
}

